import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user mr-2" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!

  return (_openBlock(), _createBlock(_component_button_dropdown, { icon: "fas fa-ellipsis-h" }, {
    default: _withCtx(() => [
      _createVNode(_component_the_button, {
        class: "small primary mr-2",
        loading: _ctx.state.is_user_session_loading,
        onClick: _ctx.createUserSession
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createTextVNode(" Войти под курьером ")
        ]),
        _: 1
      }, 8, ["loading", "onClick"]),
      _createVNode(_component_the_button, {
        class: "small primary mr-2",
        onClick: _ctx.emitUpdate
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createTextVNode(" Редактировать ")
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.isCanDelete)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 0,
            class: "text small red",
            onClick: _ctx.emitDelete
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" Удалить ")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}